import { PageLink } from "../../../../../_metronic/layout/core"
import { EMatchingPayoutTicketStatus } from "../../../../../types/enums"
import { matchingCapabilities, MatchingPayoutActiveTicketsFilters, MatchingPayoutTicketListObject } from "../../core/_models"


const defaultList: MatchingPayoutTicketListObject = {}
const perPage = 20

export const breadcrumbs: Array<PageLink> = [
  {
    title: 'Активные выплаты',
    path: '/matching/payout/active',
    isSeparator: false,
    isActive: true,
    roles: matchingCapabilities.canViewActivePayouts,
  },
  {
    title: 'Завершённые выплаты',
    path: '/matching/payout/finished',
    isSeparator: false,
    isActive: false,
    roles: matchingCapabilities.canViewFinishedPayouts,
  },
  {
    title: 'Отказы',
    path: '/matching/payout/refusals',
    isSeparator: false,
    isActive: false,
    roles: matchingCapabilities.canViewPayoutRefusals,
  },
]

const relevantStatusList: Array<EMatchingPayoutTicketStatus> = [
  EMatchingPayoutTicketStatus.MATCHING_PROCESSING,
]

const defaultFilters: MatchingPayoutActiveTicketsFilters = {
  search: '',
  merchantTokenList: [],
  paymentMethodList: [],
}

export const matchingActivePayoutsConfig = {
  breadcrumbs,
  defaultList,
  perPage,
  relevantStatusList,
  defaultFilters,
}